import React, { ReactNode, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { GlobalContext } from "../hooks/useGlobals";
import { Member } from "../lib/types/member";
import axios from "axios";
import MemberService from "../services/MemberService";

const ContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [authMember, setAuthMember] = useState<Member | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token && token != "undefined") {
      const memberService = new MemberService();
      memberService
        .authMe(String(token))
        .then((member) => setAuthMember(member))
        .catch(() => {
          setAuthMember(null);
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
        });
    }
  }, []);

  return (
    <GlobalContext.Provider value={{ authMember, setAuthMember }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default ContextProvider;
